import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import ItemInventoryView from 'src/views/ItemInventory';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true
  }
}));
export default ItemInventoryView;